import React, { useEffect, useState } from "react";
import { createPlan, getPlan, updatePlan } from "../api/postPlansApi";
import { Box, TextField, Button, Stack, MenuItem, Alert } from "@mui/material";

const FORMATS = ["talent", "reality", "factual", "docu", "branded"];
const WD_5 = ["Mon","Tue","Wed","Thu","Fri"];
const WD_6 = ["Mon","Tue","Wed","Thu","Fri","Sat"];

export default function StepSetup({ planId, registerSave }) {
  const isNew = !planId;
  const [form, setForm] = useState({
    name: "",
    format: "",
    working_days: WD_5,
    holidays: [],
    blackout_dates: []
  });
  const [turniSett, setTurniSett] = useState(5);
  const [status, setStatus] = useState({ saving: false, saved: false, error: null });

  useEffect(() => {
    if (!isNew) {
      getPlan(planId)
        .then((p) => {
          const wd = p.working_days || WD_5;
          setForm({
            name: p.name || "",
            format: p.format || "",
            working_days: wd,
            holidays: p.holidays || [],
            blackout_dates: p.blackout_dates || []
          });
          setTurniSett(wd.includes("Sat") ? 6 : 5);
        })
        .catch((e) => setStatus((s) => ({ ...s, error: e.message })));
    }
  }, [planId, isNew]);

  const onChangeTurniSett = (val) => {
    setTurniSett(val);
    setForm((f) => ({ ...f, working_days: val === 6 ? WD_6 : WD_5 }));
  };

  const save = async () => {
    setStatus({ saving: true, saved: false, error: null });
    try {
      if (isNew) {
        const payload = {
          name: form.name,
          format: form.format,
          working_days: form.working_days,
          holidays: form.holidays,
          blackout_dates: form.blackout_dates
        };
        const res = await createPlan(payload);
        await updatePlan(res.planId, { constraints: { max_turns_per_week: turniSett } });
        // quando si crea un piano nuovo, facciamo redirect diretto allo step successivo
        window.location.assign(`/piani/${res.planId}/editor?step=episodes`);
        return true;
      } else {
        await updatePlan(planId, {
          name: form.name,
          format: form.format,
          working_days: form.working_days,
          holidays: form.holidays,
          blackout_dates: form.blackout_dates,
          constraints: { max_turns_per_week: turniSett }
        });
        setStatus({ saving: false, saved: true, error: null });
        return true;
      }
    } catch (e) {
  setStatus({ saving: false, saved: false, error: e.message });
  alert(e.message || "Errore salvataggio setup");
  return false;
}
  };

  // ► collega il footer del wizard
  useEffect(() => {
    if (!registerSave) return;
    registerSave(async () => await save());
  }, [registerSave, isNew, form, turniSett]); // dipendenze conservative

  return (
    <Box maxWidth={700}>
      <Stack spacing={2}>
        {status.error && <Alert severity="error">{status.error}</Alert>}

        <TextField
          label="Nome progetto"
          value={form.name}
          required
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />

        <TextField
          select
          label="Formato/Genere"
          value={form.format}
          onChange={(e) => setForm({ ...form, format: e.target.value })}
        >
          {FORMATS.map((f) => (
            <MenuItem key={f} value={f}>{f}</MenuItem>
          ))}
        </TextField>

        <TextField
          select
          label="Turni a settimana"
          value={turniSett}
          onChange={(e) => onChangeTurniSett(Number(e.target.value))}
          helperText={turniSett === 5 ? "Lunedì–Venerdì" : "Lunedì–Sabato"}
        >
          <MenuItem value={5}>5 (L–V)</MenuItem>
          <MenuItem value={6}>6 (L–S)</MenuItem>
        </TextField>

        <Button variant="contained" onClick={save} disabled={status.saving}>
          {isNew ? "Crea e continua" : "Salva"}
        </Button>
      </Stack>
    </Box>
  );
}
